(function () {
  'use strict';

  function getLuminance(r, g, b) {
    return [r, g, b].map(function (c) {
      c /= 255;
      return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    }).reduce(function (lum, channel, i) {
      return lum + channel * [0.2126, 0.7152, 0.0722][i];
    }, 0);
  }

  function applyHeroContrast(hero, r, g, b) {
    var isLight = getLuminance(r, g, b) > 0.45;
    hero.classList.toggle('blog-article-hero--light', isLight);
    hero.classList.toggle('blog-article-hero--dark', !isLight);
  }

  function applyHeroTheme(hero, r, g, b) {
    hero.style.backgroundColor = 'rgb(' + r + ', ' + g + ', ' + b + ')';
    applyHeroContrast(hero, r, g, b);
  }

  function sampleHeroBackground(imageEl, hero) {
    try {
      var canvas = document.createElement('canvas');
      canvas.width = 1;
      canvas.height = 1;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(imageEl, 0, 0, 1, 1, 0, 0, 1, 1);
      var data = ctx.getImageData(0, 0, 1, 1).data;
      applyHeroTheme(hero, data[0], data[1], data[2]);
    } catch (error) {
      hero.classList.add('blog-article-hero--dark');
    }
  }

  function initHero() {
    var seeMore = document.getElementById('seeMoreBtn');
    var imgExpand = document.querySelector('.blog-article-hero__image.imgexpand') || document.querySelector('.imgexpand');
    if (seeMore && imgExpand) {
      seeMore.addEventListener('click', function (event) {
        event.preventDefault();
        var currentScrollY = window.scrollY;
        imgExpand.classList.toggle('expanded');
        if (imgExpand.classList.contains('expanded')) {
          window.scrollTo(0, currentScrollY);
        }
      });
    }

    var hero = document.getElementById('blogArticleHero');
    var targetImage = document.getElementById('targetImage');
    if (!hero) return;

    var presetHex = hero.getAttribute('data-hero-colour');
    if (presetHex) {
      var hex = presetHex.replace('#', '');
      if (hex.length === 3) hex = hex.split('').map(function (c) { return c + c; }).join('');
      var n = parseInt(hex, 16);
      if (!isNaN(n)) applyHeroContrast(hero, (n >> 16) & 255, (n >> 8) & 255, n & 255);
      return;
    }

    if (!targetImage) return;

    if (targetImage.complete && targetImage.naturalWidth) {
      sampleHeroBackground(targetImage, hero);
    } else {
      targetImage.addEventListener('load', function () {
        sampleHeroBackground(targetImage, hero);
      }, { once: true });
    }
  }

  function initWidgetPlaceholders() {
    var widgets = {
      'featured image widget': 'tpl-featured-image-widget',
      'featured product widget': 'tpl-featured-product-widget'
    };
    var root = document.getElementById('article-body');
    if (!root) return;

    root.querySelectorAll('p').forEach(function (p) {
      var key = (p.textContent || '').trim().toLowerCase();
      if (!widgets[key]) return;
      var tpl = document.getElementById(widgets[key]);
      if (!tpl) return;
      p.replaceWith(tpl.content.cloneNode(true));
    });
  }

  function initLightbox() {
    var currentGroup = null;
    var currentIndex = 0;
    var isLoading = false;
    var lbEl = document.getElementById('tc-lightbox');
    var lbImg = document.getElementById('tc-lightbox-img');
    var lbPrev = document.querySelector('.tc-lb-prev');
    var lbNext = document.querySelector('.tc-lb-next');
    if (!lbEl || !lbImg || !lbPrev || !lbNext) return;

    var lbModal = window.bootstrap && window.bootstrap.Modal
      ? new window.bootstrap.Modal(lbEl)
      : {
          show: function () { window.jQuery(lbEl).modal('show'); },
          hide: function () { window.jQuery(lbEl).modal('hide'); }
        };

    function getGroup(groupName) {
      return Array.from(document.querySelectorAll('.tc-img-thumb[data-group="' + groupName + '"]'))
        .sort(function (a, b) { return parseInt(a.dataset.index, 10) - parseInt(b.dataset.index, 10); });
    }

    function updateNavButtons() {
      var group = getGroup(currentGroup);
      if (!group.length) return;
      var indices = group.map(function (t) { return parseInt(t.dataset.index, 10); });
      lbPrev.style.display = currentIndex <= Math.min.apply(null, indices) ? 'none' : '';
      lbNext.style.display = currentIndex >= Math.max.apply(null, indices) ? 'none' : '';
    }

    function setLoadingState(loading) {
      isLoading = loading;
      var navOpacity = loading ? '0.35' : '';
      var navEvents = loading ? 'none' : '';
      lbPrev.style.opacity = navOpacity;
      lbNext.style.opacity = navOpacity;
      lbPrev.style.pointerEvents = navEvents;
      lbNext.style.pointerEvents = navEvents;
      lbImg.style.opacity = loading ? '0.45' : '1';
    }

    function preloadAdjacent() {
      var group = getGroup(currentGroup);
      [-1, 1].forEach(function (dir) {
        var adjIndex = currentIndex + dir;
        for (var i = 0; i < group.length; i++) {
          if (parseInt(group[i].dataset.index, 10) === adjIndex) {
            var pre = new Image();
            pre.src = group[i].dataset.full;
            break;
          }
        }
      });
    }

    function openLightbox(thumb) {
      currentGroup = thumb.dataset.group;
      currentIndex = parseInt(thumb.dataset.index, 10);
      isLoading = false;
      var thumbImg = thumb.querySelector('img');
      lbImg.alt = thumbImg ? thumbImg.alt : '';
      lbImg.src = thumb.dataset.full;
      lbImg.style.opacity = '1';
      updateNavButtons();
      lbModal.show();
      preloadAdjacent();
    }

    function navigate(dir) {
      if (isLoading) return;
      var group = getGroup(currentGroup);
      var newIndex = currentIndex + dir;
      var thumb = null;
      for (var i = 0; i < group.length; i++) {
        if (parseInt(group[i].dataset.index, 10) === newIndex) {
          thumb = group[i];
          break;
        }
      }
      if (!thumb) return;

      setLoadingState(true);
      var loader = new Image();
      loader.onload = loader.onerror = function () {
        currentIndex = newIndex;
        var thumbImage = thumb.querySelector('img');
        lbImg.alt = thumbImage ? thumbImage.alt : '';
        lbImg.src = thumb.dataset.full;
        setLoadingState(false);
        updateNavButtons();
        preloadAdjacent();
      };
      loader.src = thumb.dataset.full;
    }

    document.addEventListener('click', function (e) {
      var thumb = e.target.closest('.tc-img-thumb');
      if (thumb) openLightbox(thumb);
    });

    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') &&
          document.activeElement &&
          document.activeElement.classList.contains('tc-img-thumb')) {
        e.preventDefault();
        openLightbox(document.activeElement);
        return;
      }
      if (!lbEl.classList.contains('show')) return;
      if (e.key === 'ArrowRight') navigate(1);
      if (e.key === 'ArrowLeft') navigate(-1);
    });

    lbPrev.addEventListener('click', function () { navigate(-1); });
    lbNext.addEventListener('click', function () { navigate(1); });

    var touchStartX = 0;
    lbEl.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].clientX;
    }, { passive: true });
    lbEl.addEventListener('touchend', function (e) {
      var delta = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(delta) > 50) navigate(delta < 0 ? 1 : -1);
    }, { passive: true });
  }

  function initSingleProductWidgets() {
    var poolCards = Array.from(document.querySelectorAll('#spw-pool .product-widget-card'));
    if (!poolCards.length) return;

    var placeholders = Array.from(document.querySelectorAll('#article-body p'));
    var re = /^Single Product Widget SKU:\s*([A-Za-z0-9._\-]+)/i;
    var used = new Set();

    placeholders.forEach(function (p) {
      var match = (p.textContent || '').trim().match(re);
      if (!match) return;

      var wantedSku = match[1].toUpperCase();
      var card = poolCards.find(function (div) {
        if (used.has(div)) return false;
        var list = (div.getAttribute('data-skus') || '').toUpperCase().split(',').map(function (s) {
          return s.trim();
        }).filter(Boolean);
        return list.indexOf(wantedSku) !== -1;
      });

      if (card) {
        card.classList.remove('spw-hidden');
        p.replaceWith(card);
        used.add(card);
      }
    });

    var leftovers = poolCards.filter(function (div) { return !used.has(div); });
    if (!leftovers.length) return;

    var report = document.getElementById('spw-unused-report');
    if (report) {
      var ul = document.createElement('ul');
      ul.setAttribute('data-spw-unused-count', String(leftovers.length));
      leftovers.forEach(function (div) {
        var li = document.createElement('li');
        var title = div.getAttribute('data-title') || '(untitled)';
        var skus = (div.getAttribute('data-skus') || '').split(',').filter(Boolean).join(', ');
        li.textContent = title + ' — SKUs: ' + skus;
        ul.appendChild(li);
      });
      report.appendChild(ul);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHero();
    initWidgetPlaceholders();
    initLightbox();
    initSingleProductWidgets();
  });
})();
